















import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ALLOWED_ROLES } from '@/constants'
import LogOut from '@/features/navBar/components/LogOut.vue'
import SwitchCustomer from '@/features/navBar/components/SwitchCustomer.vue'
import User from '@/features/navBar/components/User.vue'
import Home from '@/features/navBar/components/Home.vue'
import { IUser } from '@/features/auth/store'
import { GET_USER } from '@/system/store/getter-types'
@Component({
  components: {
    LogOut,
    SwitchCustomer,
    User,
    Home
  }
})
export default class TopBarView extends Vue {
  private allowedRoles = ALLOWED_ROLES

  @Getter(GET_USER)
  user!: IUser

  private get isAllowSwitch (): boolean {
    if (this.user.isAgentUser) {
      return true
    }
    return this.allowedRoles.includes(this.user.role)
  }
}
